import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

const NavbarLinks = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const navigate = useNavigate();
  const location = useLocation();

  const tabs =
      isAuthenticated ?
          [
            {label: 'Market', path: '/market'},
            {label: 'On Sale', path: '/on-sale'},
            {label: 'Database', path: '/database'},
          ] : [
            {label: 'Market', path: '/market'},
            {label: 'Database', path: '/database'},
          ];

  return (
      <div className="flex items-center xl:space-x-4 space-x-1 relative">

        {tabs.map((item) => {
          const isActive = location.pathname === item.path;

          return (
              <button
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  // Added whitespace-nowrap to prevent line breaks in labels
                  className="relative px-3 py-2 text-sm font-semibold transition-all duration-300 rounded-md group whitespace-nowrap"
              >

                {/* Hover background */}
                <span
                    className={`absolute inset-0 rounded-md transition-all duration-300 ${isActive ? '' : 'group-hover:bg-white/5'}`}
                />

                {/* Text */}
                <span
                    className={`relative z-10 transition-colors ${isActive ? 'text-white' : 'text-neutral-400 group-hover:text-white'}`}
                >
              {item.label}
            </span>

                {/* Active glow */}
                {isActive && (
                    <span className="absolute inset-0 rounded-md bg-dark-primary/20 blur-2xl pointer-events-none"></span>
                )}

                {/* Active underline */}
                {isActive && (
                    <span
                        className="absolute left-0 right-0 -bottom-1 mx-auto h-[2px] bg-dark-primary rounded-full shadow-[0_0_14px_4px_rgba(63,81,181,0.8)] transition-all duration-300"
                    />
                )}
              </button>
          );
        })}

      </div>
  );
};

export default NavbarLinks;